import { Dialog } from "radix-ui"
import { FaTimes } from "@react-icons/all-files/fa/FaTimes"
import { Value } from "@stringtale/react"
import { LandscapeYoutubePlayer } from "app/content-blocks/components/YoutubePlayer"
import HomeModalButton from "app/home/components/HomeModalButton"
import { PageType } from "db/enums"
import { AnimatePresence, motion } from "framer-motion"
import Link from "next/link"
import { useState } from "react"
import { flushSync } from "react-dom"
import { DARK_BLUE_COLOR } from "theme/colors"
import { PX14, PX24 } from "theme/sizes"
import Group from "ui/Group"
import { Close, Content, Overlay, Root } from "ui/Modal"
import RoundedButton from "ui/RoundedButton"
import Stack from "ui/Stack"
import Text from "ui/Text"
import Title from "ui/Title"

// Home modal disabled as of 2025-08-01 - https://app.asana.com/1/1147785086346889/inbox/1171671462131767/item/1210934890353356/story/1210935690788572
// To enable, uncomment <HomeModal state={stateHomeModal} toggle={toggleHomeModal} /> in pages/index.tsx around L585
export const HOME_MODAL_KEY: PageType = "HOME_NIEUWSFLITS_22" // READ NOTE ABOVE

export default function HomeModal({
  state,
  toggle,
}: {
  state: "OPENED" | "MINIMIZED" | "CLOSED"
  toggle: (state: "OPENED" | "MINIMIZED" | "CLOSED") => void
}) {
  // const [state, toggle] = useState("MINIMIZED")
  const modalActive = state === "OPENED"
  if (state === "CLOSED") {
    return null
  }

  return (
    <>
      {!modalActive && (
        <HomeModalButton
          onClose={() => toggle("CLOSED")}
          positionSelf={false}
          onClick={() => {
            toggle("OPENED")
          }}
          style={{
            viewTransitionName: "home-modal",
          }}
        >
          <Text
            size={PX14}
            bold
            color={DARK_BLUE_COLOR}
            style={{
              viewTransitionName: "home-modal-title",
            }}
          >
            <Value name="apps.web.src.home.components.homemodal.button">
              Nieuwsflits #22
            </Value>
          </Text>
        </HomeModalButton>
      )}
      <Dialog.Root
        open={modalActive}
        onOpenChange={(val) => toggle(val ? "OPENED" : "MINIMIZED")}
      >
        <Dialog.Portal>
          <Dialog.Overlay asChild>
            <Overlay
              style={{
                viewTransitionName: "home-modal-overlay",
              }}
            />
          </Dialog.Overlay>
          <Dialog.Content>
            <Root
              style={{
                viewTransitionName: "home-modal",
                // @ts-ignore
                viewTransitionClass: "content",
              }}
            >
              <Content>
                <Stack gap="32px">
                  <div>
                    <Title
                      size={PX24}
                      style={{
                        viewTransitionName: "home-modal-title",
                        display: "inline",
                      }}
                    >
                      <Value name="apps.web.src.home.components.homemodal.title">
                        Nieuwsflits #22
                      </Value>
                    </Title>
                  </div>
                  <Stack gap="24px">
                    <LandscapeYoutubePlayer videoId={"w76lj4qWwdQ"} />
                    <Stack>
                      <Value
                        name="apps.web.src.home.components.homemodal.body"
                        format={{
                          p: (c) => <p>{c}</p>,
                          li: (c) => <li>{c}</li>,
                          ul: (c) => <ul>{c}</ul>,
                          b: (c) => <b>{c}</b>,
                          aftellenLink: (c) => (
                            <Link
                              href={"https://www.123zing.nl/aftellen"}
                              target="_blank"
                              referrerPolicy="no-referrer"
                            >
                              {c}
                            </Link>
                          ),
                          teamtrainingLink: (c) => (
                            <Link
                              href={"https://www.123zing.nl/teamtrainingen"}
                              target="_blank"
                              referrerPolicy="no-referrer"
                            >
                              {c}
                            </Link>
                          ),
                          userExperienceLink: (c) => (
                            <Link
                              href={"https://www.mijn.123zing.nl/leerkracht"}
                              target="_blank"
                              referrerPolicy="no-referrer"
                            >
                              {c}
                            </Link>
                          ),
                        }}
                      >
                        {`<p>In deze aflevering:
                        <ul>
                          <li><aftellenLink>Aftellen tot de zomer</aftellenLink></li>
                          <li>Nieuw lesmateriaal</li>
                          <li>Teaser: Kinderboekenweek 2025!</li>
                          <li>Zomeractie: <teamtrainingLink>Teamtraining met korting</teamtrainingLink></li>
                          <li><userExperienceLink>Gebruikerservaringen</userExperienceLink></li>
                          <li>Wist je dat? Burgerschap!</li>
                        </ul>
                        </p>
                       `}
                      </Value>
                    </Stack>
                  </Stack>
                  <Group gap="8px" justify="right">
                    <Dialog.Close asChild>
                      <RoundedButton variant="filled">
                        <Value name="apps.web.src.news.components.home.sluiten">
                          Later bekijken
                        </Value>
                      </RoundedButton>
                    </Dialog.Close>
                    {/* <RoundedButton variant="filled">
                    <Value name="apps.web.src.news.components.home.meer_informatie">
                      Meer informatie
                    </Value>
                  </RoundedButton> */}
                  </Group>
                </Stack>
                <Dialog.Close asChild>
                  <Close>
                    <FaTimes />
                  </Close>
                </Dialog.Close>
              </Content>
            </Root>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  )
}
